var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorporate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 37h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 45h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 53h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 37h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 29h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 29h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 45h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 45h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 45h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 45h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 30c0-.553-.447-1-1-1h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1zm-2 3h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 30c0-.553-.447-1-1-1h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1zm-2 3h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 30c0-.553-.447-1-1-1h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1zm-2 3h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 38c0-.553-.447-1-1-1h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1zm-2 3h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 38c0-.553-.447-1-1-1h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1zm-2 3h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 38c0-.553-.447-1-1-1h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1zm-2 3h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 53h-4c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h4c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1zm-1 4h-2v-2h2z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 61v-35c0-.553-.447-1-1-1h-1v-3c0-.553-.447-1-1-1h-11v-3c0-.553-.447-1-1-1h-4v2h3v42h-8v-7c0-.553-.447-1-1-1h-8c-.553 0-1 .447-1 1v7h-8v-42h3v-2h-4c-.553 0-1 .447-1 1v3h-11c-.553 0-1 .447-1 1v3h-1c-.553 0-1 .447-1 1v35h-2v2h62v-2zm-4-38v2h-10v-2zm-10 4h12v34h-12zm-18 28h6v6h-6zm-22-32h10v2h-10zm-2 4h12v34h-12z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.138 20.575 1.914 5.741c.136.409.517.684.948.684s.812-.275.948-.684l1.914-5.741c4.231-1.257 7.138-5.116 7.138-9.575 0-5.514-4.486-10-10-10s-10 4.486-10 10c0 4.459 2.907 8.318 7.138 9.575zm2.862-17.575c4.411 0 8 3.589 8 8 0 3.719-2.527 6.916-6.147 7.775-.336.08-.607.328-.717.656l-1.136 3.407-1.136-3.406c-.109-.328-.381-.576-.717-.656-3.62-.86-6.147-4.057-6.147-7.776 0-4.411 3.589-8 8-8z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 17c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zm0-10c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z",
    fill: "#555555",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.53c21aa9.svg";
export { ForwardRef as ReactComponent };